import { ICategoryTypeRecord, CategoryTypeCrudClassProxy, categoryTypeCrudClassProxy } from '@src/framework/crud/meta/CategoryTypeCrud';
import RecordEditor from '@framework/forms/recordeditor';


export default class CategoryTypeEditor extends RecordEditor<ICategoryTypeRecord> {
    //protected getHeader = () : JSX.Element|null => { return <MetaMenu /> }
    public getCrudClassProxy() : CategoryTypeCrudClassProxy { return categoryTypeCrudClassProxy;  }  
}